<div class="titulo">
  <span class="titulo-texto">Precio de Lista</span>
  <mat-icon
    (click)="cerrarModal()"
    class="titulo-boton"
    >close</mat-icon
  >
</div>
<div
  class="cuota {{ cuota !== 1 ? 'borderTop' : '' }}"
  *ngFor="let cuota of cuotas">
  <div class="cuota-cantidad">
    <strong>{{ cuota }}</strong> cuota{{ cuota !== 1 ? 's' : '' }} fija{{
      cuota !== 1 ? 's' : ''
    }}
    de
  </div>
  <div class="cuota-valor">
    <strong><span class="signo$">$</span> {{ precioLista / cuota | number: '1.2-2' }}</strong>
  </div>
  <div class="cuota-total">
    (Total <span class="signo$">$</span> {{ precioLista | number: '1.2-2' }})
  </div>
</div>
<p class="leyenda">La cantidad de cuotas disponibles puede variar dependiendo de la tarjeta.</p>
